import { API, getToken } from "./api";

// Téléchargements hors ligne explicites : cache Cache Storage partagé avec le service worker
// (clé = URL sans token, le SW sert ces fichiers en priorité cache quand le réseau manque).
const FILES_CACHE = "rannea-files";
const fileUrlFor = (id) => `${API}/files/${id}/content`;

export const isFileOffline = async (id) => {
  try {
    const cache = await caches.open(FILES_CACHE);
    return !!(await cache.match(fileUrlFor(id), { ignoreSearch: true }));
  } catch {
    return false;
  }
};

export const saveFileOffline = async (id) => {
  const res = await fetch(fileUrlFor(id), { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!res.ok) throw new Error("download_failed");
  const cache = await caches.open(FILES_CACHE);
  await cache.put(fileUrlFor(id), res);
  window.dispatchEvent(new Event("rannea-offline-changed"));
};

export const removeFileOffline = async (id) => {
  const cache = await caches.open(FILES_CACHE);
  const keys = await cache.keys();
  await Promise.all(keys.filter((k) => k.url.startsWith(fileUrlFor(id))).map((k) => cache.delete(k)));
  window.dispatchEvent(new Event("rannea-offline-changed"));
};

export const offlineFilesCount = async () => {
  try {
    const cache = await caches.open(FILES_CACHE);
    return (await cache.keys()).length;
  } catch {
    return 0;
  }
};

export const clearOfflineFiles = async () => {
  await caches.delete(FILES_CACHE);
  window.dispatchEvent(new Event("rannea-offline-changed"));
};

export const storageEstimate = async () => {
  try {
    const est = await navigator.storage.estimate();
    return { used: est.usage || 0, quota: est.quota || 0 };
  } catch {
    return { used: 0, quota: 0 };
  }
};
